var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dadosCadastros
    ? _c(
        "validation-observer",
        { ref: "validation", staticClass: "analise", attrs: { tag: "div" } },
        [
          _c(
            "el-card",
            { staticClass: "card-collapse", attrs: { shadow: "hover" } },
            [
              _c("app-header-dados-processo", {
                attrs: {
                  processo: _vm.processo,
                  isCCR: _vm.isCCR,
                  dadosCadastros: _vm.dadosCadastros,
                  numeroTituloDominial: _vm.numeroTituloDominial,
                  numeroProcessoFisico: _vm.numeroProcessoFisico,
                  dataEmissaoTituloDominial: _vm.dataEmissaoTituloDominial
                }
              })
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "el-card",
                { staticClass: "card-collapse", attrs: { shadow: "hover" } },
                [
                  _c("app-despachos", {
                    attrs: {
                      idProcesso: _vm.idProcesso,
                      data: _vm.dadosCadastros.setores,
                      tituloMinuta:
                        _vm.dadosCadastros.despacho.processo.tipo.codigo ===
                        "CERTIDAO_TITULO"
                          ? "Minuta da certidão"
                          : "Minuta do título"
                    },
                    on: { getDownload: _vm.getDownload }
                  }),
                  _vm.documentosValidar &&
                  !_vm.isRetornarOuArquivar &&
                  _vm.showValidacaoDocumentos
                    ? _c("app-dados-cadastro", {
                        attrs: {
                          dadosCadastros: _vm.responseAnalise.dadosCadastros
                        },
                        on: {
                          setValidacaoDocumentos: _vm.setValidacaoDocumentos,
                          downloadDocumentoCadastro:
                            _vm.downloadDocumentoCadastro,
                          setDocumentosValidar: _vm.setDocumentosValidar
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticStyle: { margin: "15px" }, attrs: { span: 6 } },
            [
              _c("app-label", {
                attrs: {
                  label: "Processo SEI (Sistema Eletrônico de Informações):",
                  required: true
                }
              }),
              _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var errors = ref.errors
                        return [
                          _c(
                            "el-input",
                            {
                              staticClass: "input",
                              class: {
                                erro:
                                  errors.length &&
                                  !_vm.dadosCadastros.despacho.numeroSei
                              },
                              attrs: { name: "N° SEI" },
                              model: {
                                value: _vm.numeroSei,
                                callback: function($$v) {
                                  _vm.numeroSei = $$v
                                },
                                expression: "numeroSei"
                              }
                            },
                            [
                              _c("el-button", {
                                staticStyle: { color: "#009f61" },
                                attrs: { slot: "append", icon: "el-icon-plus" },
                                on: {
                                  click: function($event) {
                                    return _vm.addNumeroSei()
                                  }
                                },
                                slot: "append"
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticStyle: { "margin-top": "10px" } },
                            [
                              _vm.dadosCadastros.despacho.numeroSei
                                ? _c(
                                    "el-tag",
                                    {
                                      staticStyle: { margin: "5px" },
                                      attrs: {
                                        closable: "closable",
                                        type: "info",
                                        size: "medium"
                                      },
                                      on: {
                                        close: function($event) {
                                          return _vm.removeNumeroSei()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.dadosCadastros.despacho.numeroSei
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          errors.length &&
                          !_vm.dadosCadastros.despacho.numeroSei
                            ? _c("span", { staticClass: "help erro" }, [
                                _vm._v(_vm._s(errors[0]))
                              ])
                            : _vm._e()
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3996749561
                )
              })
            ],
            1
          ),
          _vm.dadosCadastros
            ? _c(
                "el-card",
                { staticClass: "card-collapse", attrs: { shadow: "hover" } },
                [
                  _vm.showDespachoAndAnexo()
                    ? _c(
                        "div",
                        [
                          _c("validation-provider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "flex-despacho" },
                                        [
                                          _c("p", { staticClass: "label" }, [
                                            _vm._v(
                                              _vm._s(_vm.formatterTipoDespacho)
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "required" },
                                              [_vm._v("  *  ")]
                                            )
                                          ])
                                        ]
                                      ),
                                      _c("app-editor-texto", {
                                        ref: "editorTexto",
                                        staticClass: "input",
                                        class: { erro: errors.length },
                                        on: { onTextChange: _vm.onTextChange },
                                        model: {
                                          value:
                                            _vm.dadosCadastros.despacho
                                              .textoDespacho,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.dadosCadastros.despacho,
                                              "textoDespacho",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "dadosCadastros.despacho.textoDespacho"
                                        }
                                      }),
                                      _c("span", { staticClass: "help erro" }, [
                                        _vm._v(_vm._s(errors[0]))
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2731890629
                            )
                          }),
                          _vm.anexos && _vm.dadosCadastros.despacho
                            ? _c("app-anexo", {
                                attrs: {
                                  id: "upload-anexo-despacho",
                                  files: _vm.anexos,
                                  tipoExibir: "ANEXO_ANALISE"
                                },
                                on: {
                                  uploadFile: _vm.uploadFile,
                                  removeFile: _vm.removeFile,
                                  downloadDocumentoCadastro:
                                    _vm.downloadDocumentoCadastro
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0037b388", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0037b388","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/AnalisarValidarProcessoBa.vue
// module id = null
// module chunks = 